<template>
  <div>
    <el-table
      :data="piStatusList"
      style="width: 100%"
      :show-header="false"
    >
      <el-table-column>
        <template slot-scope="scope">
          <el-button
            type="text"
            size="mini"
            @click="updateStatus(scope.row.value)"
            :disabled="checkStatusDisabled(scope.row.value)"
          >
            <span style="margin-left: 25px">
              <img
                slot="reference"
                :src="bindIcon(scope.row.value)"
                style="width: 15px; height: 15px"
              />
            </span>
            <span
              style="
                float: right;
                color: #8492a6;
                font-size: 12px;
                margin-left: 15px;
              "
            >
              {{ scope.row.label }}

            </span>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import api from '@/api'
import { Message } from 'element-ui'
import { find } from 'lodash'
export default {
  data () {
    return {
      value: '',
      visible: false,
      text: '',
      piStatusList: [
        {
          value: 'Online',
          label: '待機中'
        },
        {
          value: 'OnThePhone',
          label: '応対中',
          disabled: true
        },
        {
          value: 'Busy',
          label: '作業中'
        },
        {
          value: 'Away',
          label: '応対不可'
        }
        // {
        //   value: 'Offline',
        //   label: '応対不可AA'
        // }
      ]
    }
  },
  watch: {},
  mounted () {
  },
  methods: {
    bindIcon (icon) {
      if(icon == 'OnThePhone'){
        switch(this.$store.state.sysInit.personalSingleMode) {
          case 'STAND_MIC_MODE': 
            icon = 'OnThePhone_F2F';
            break;
          case 'NEXMO_ASTERISK_PBX_MODE':
            icon = 'OnThePhone_TEL';
            break;
        }
      }
      return require('@/assets/img/' + icon + '.svg')
    },
    updateStatus(status){
      sessionStorage.setItem('currentStatus_Storage', status)
      this.$emit('update-status',status)
    },
    checkStatusDisabled(status){
      if(this.$store.state.sysInit.personalSingleMode == 'NEXMO_ASTERISK_PBX_MODE' && this.$store.state.phone.inCallList.length >0) return true
      if(status == 'OnThePhone') return true
    }
  }
}
</script>

<style></style>
